import SvgLocation from '@sats-group/icons/18/location';
import SvgPtLabel from '@sats-group/icons/18/pt-label';
import Link from '@sats-group/ui-lib/react/link';
import Tag from '@sats-group/ui-lib/react/tag';
import Text from '@sats-group/ui-lib/react/text';
import VisuallyButton from '@sats-group/ui-lib/react/visually-button';
import React from 'react';
import DateAndTime from '../date-and-time/date-and-time';
import type { DisplayBootCampEvents as Props } from './display-boot-camp-events.types';

const DisplayBootCampEvents: React.FunctionComponent<Props> = ({
  events,
  nullState,
}) => (
  <div className="display-boot-camp-events">
    {events.map(event => (
      <div key={event.id} className="display-boot-camp-events__event">
        <a
          className="display-boot-camp-events__info"
          data-club-id={event.clubId}
          data-concept-id={event.conceptId}
          key={event.id}
          href={event.href}
        >
          <div className="display-boot-camp-events__event-main">
            <Text theme={Text.themes.emphasis}>{event.conceptName}</Text>
          </div>
          <div className="display-boot-camp-events__pt">
            <Tag
              {...event.pt}
              icon={<SvgPtLabel />}
              size={Tag.sizes.s}
              variant={Tag.variants.neutral}
            />
          </div>
          <div className="display-boot-camp-events__location">
            <Tag
              {...event.location}
              icon={<SvgLocation />}
              size={Tag.sizes.s}
              variant={Tag.variants.neutral}
            />
          </div>
          <div className="display-boot-camp-events__date-time-wrapper">
            <DateAndTime {...event.datetime} />
          </div>

          <div className="display-boot-camp-events__spots">
            <Tag {...event.availableSpots} size={Tag.sizes.s} />
          </div>
          <div className="display-boot-camp-events__action">
            <VisuallyButton
              {...event.button}
              size={VisuallyButton.sizes.small}
              variant={VisuallyButton.variants.secondary}
              wide
            />
          </div>
        </a>
      </div>
    ))}
    {nullState ? (
      <div className="display-boot-camp-events__no-upcoming">
        <Text>{nullState.title}</Text>
        {nullState.prompt ? (
          <div className="display-boot-camp-events__no-upcoming-prompt">
            <Text theme={Text.themes.emphasis}>{nullState.prompt.title}</Text>
            <Text>{nullState.prompt.text}</Text>
          </div>
        ) : null}
        <Link {...nullState.link} />
      </div>
    ) : null}
  </div>
);

export default DisplayBootCampEvents;
